import Image from "next/image";
import ImageWithLoader from "../imageWithLoader/ImageWithLoader";
import { isValidImageSrc } from "@/app/utils/isValidImageSrc";

const SinglePartner = ({ image, degree, index, optimizedImage }: { image?: string, degree: number, index: number, optimizedImage?: boolean }) => {
	if (!isValidImageSrc(image)) return null;
	return (
		<div style={{transform: `rotate(${degree}deg)`}} className="absolute partner-rotate w-full h-full">
			<div className={"partner-wrapper w-full h-full"}>
					<div style={{transform: `rotate(${-degree}deg)`}} className={`partner-circle ${index > 1 ? "change_shadow_direction" : ""} flex items-center justify-center w-[20.78vw] h-[20.78vw] lg:w-[17.78vh] lg:h-[17.78vh] rounded-full bg-white`}>
						<div className="relative w-[60%] h-[60%] lg:w-[50%] lg:h-[50%]">
							{optimizedImage ? (
								<ImageWithLoader
									src={image}
									alt="partner"
									sizeVariant="icon"
									contain
									quality={80}
								/>
							) : (
								<Image src={image} alt="partner" fill className="object-center object-contain" />
							)}
						</div>
					</div>
			</div>
		</div>
	);
};

export default SinglePartner;
